/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Pale_Deer_RushInputs */

const en_teal_pale_deer_rush = /** @type {(inputs: Teal_Pale_Deer_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequent`)
};

const de_teal_pale_deer_rush = /** @type {(inputs: Teal_Pale_Deer_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufig`)
};

/**
* | output |
* | --- |
* | "Frequent" |
*
* @param {Teal_Pale_Deer_RushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_pale_deer_rush = /** @type {((inputs?: Teal_Pale_Deer_RushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Pale_Deer_RushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_pale_deer_rush(inputs)
	return de_teal_pale_deer_rush(inputs)
});